<template>
  <q-page padding>
      <q-table title="Components"
               :data="components"
               :columns="columns"
               :pagination.sync="pagination"
               :filter="filter"
               row-key="id">

        <template v-slot:top>
          <div class="text-h4">Components</div>
          <q-space />
          <q-input dense debounce="300" color="primary" v-model="filter">
            <template v-slot:append>
              <q-icon name="search" />
            </template>
          </q-input>
        </template>

        <q-td slot="body-cell-enabled" slot-scope="props" :props="props" >
          <!--{{ JSON.stringify(props, null, 2) }}-->
          <!--{{ JSON.stringify(props.value, null, 2) }}-->
          <q-checkbox v-model="props.row.enabled" @input="updateComponentEnabled(props)"/>
        </q-td>
        <q-td slot="body-cell-publisher" slot-scope="props" :props="props" >
          <router-link class="item item-link" :to="'/users/' + props.row.publisher" v-if="props.row.publishedId">
            @{{props.row.publisher}}
          </router-link>
          <div v-else>
            Not Published
          </div>
        </q-td>
        <q-td slot="body-cell-actions" slot-scope="props" :props="props" >
          <q-btn
            dense
            flat
            icon="edit"
            v-if="!props.row.publisher"
            @click="$router.push('/components/' + props.row.id + '/edit')">
            <q-tooltip :offset="[0, 10]">Edit</q-tooltip>
          </q-btn>
          <q-btn
            dense
            flat
            icon="mdi-eye"
            v-if="props.row.publisher"
            @click="$router.push('/public-components/' + props.row.publishedId)">
            <q-tooltip :offset="[0, 10]">View</q-tooltip>
          </q-btn>
          <q-btn
            dense
            flat
            icon="content_copy"
            @click="copyComponent(props.row)">
            <q-tooltip :offset="[0, 10]">Clone</q-tooltip>
          </q-btn>
          <q-btn
            dense
            flat
            icon="delete"
            @click="deleteComponent(props.row)">
            <q-tooltip :offset="[0, 10]">Delete</q-tooltip>
          </q-btn>
          <q-btn
            dense
            flat
            icon="file_download"
            @click="downloadComponent(props.row)">
            <q-tooltip :offset="[0, 10]">Download</q-tooltip>
          </q-btn>
          <q-btn
            dense
            flat
            icon="publish"
            :disabled="props.row.publisher"
            @click="publishComponent(props.row)">
            <q-tooltip :offset="[0, 10]">Publish</q-tooltip>
          </q-btn>
        </q-td>
      </q-table>
      <q-btn class="q-ma-md" @click="$router.push('/public-components')">Public Components</q-btn>
      <q-btn class="q-ma-md" @click="addNewComponent">Add New</q-btn>
  </q-page>
</template>

<script>
import firestore from '../store/firestore'
export default {
  // name: 'PageName',
  data () {
    return {
      filter: '',
      pagination: {
        sortBy: null, // String, column "name" property value
        descending: false,
        page: 1,
        rowsPerPage: 5 // current rows per page being displayed
      },
      columns: [
        {
          name: 'enabled',
          required: true,
          label: 'Enabled',
          align: 'center',
          field: 'enabled',
          sortable: true,
          sort: (a, b) => (a < b) * 2 - 1
        },
        {
          name: 'name',
          required: true,
          label: 'Name',
          align: 'left',
          field: 'name',
          sortable: true
        },
        {
          name: 'publisher',
          required: true,
          label: 'Author',
          align: 'left',
          field: 'publisher',
          sortable: true
        },
        {
          name: 'actions',
          required: true,
          label: 'Actions',
          align: 'center',
          field: null,
          sortable: false
        }
      ]
    }
  },
  computed: {
    components () { return this.$store.getters.getComponentsAsAry }
  },
  methods: {
    updateComponentEnabled (v) {
      this.$store.dispatch('updateComponentEnabled', v.row)
    },
    copyComponent (row) {
      let clone = Object.assign({}, row)
      clone.name += ' copy'
      delete clone.publisher
      delete clone.publishedId
      this.$store.dispatch('addComponent', clone)
    },
    deleteComponent (row) {
      this.$q.dialog({
        title: 'Delete Component ?',
        message: 'Are you sure you want to delete the component named \'' + row.name + '\'?',
        ok: true,
        cancel: true,
        position: 'top'
      }).then(() => {
        return this.$store.dispatch('deleteComponentWithId', row.id)
      })
    },
    downloadComponent (row) {
    },
    publish (component) {
      firestore.functions().httpsCallable('publishComponent')({ componentId: component.id }).then((result) => {
        this.$q.notify({
          message: 'Published Component!',
          type: 'positive'
        })
      }).catch((err) => {
        this.$q.notify({
          message: 'Could not publish component. ' + err,
          type: 'negative'
        })
      })
    },
    publishComponent (row) {
      let vm = this
      let p = Promise.resolve(null)
      if (!row.publishedId) {
        p = vm.$q.dialog({
          title: 'Publish',
          message: 'Do you want to publish this component?',
          ok: true,
          cancel: true
        }).then(() => {
          return this.publish(row)
        })
      }
      p.then(() => {
        return vm.$q.dialog({
          title: 'Component Published',
          message: 'id = ' + row.publishedId,
          cancel: 'Ok',
          ok: 'Delete!'
        })
      }).then(() => {
        return vm.$q.dialog({
          title: 'Delete',
          message: 'Are you sure you want to un-publish this note?' +
          'Others will then be unable to view it',
          ok: 'Delete',
          cancel: true
        })
      }).then((cancelled) => {
        if (cancelled) return
        vm.noteHelper.unpublish().catch((ex) => {
          vm.$q.notify('Unable to unpublish.')
          console.log(ex)
        })
      })
    },
    addNewComponent () {
      this.$store.dispatch('addComponent', null)
    }
  }
}
</script>

<style>
</style>
